<template>
  <div>
    <transition name="fade">
      <div v-if="alert.visibility" class="form__alert">
        <v-icon color="error">warning</v-icon>
        <span>{{ alert.message }}</span>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'FormAlert',
  props: {
    alert: {
      type: Object,
      default: () => ({
        visibility: false,
        message: null
      })
    }
  },

  data () {
    return {
      namespace: 'Views.ConsolidatedReportPage'
    }
  }
}
</script>

<style lang="scss" scoped>
.form__alert {
  background-color: #f2dede;
  border-bottom: 1px solid #d6d6d6;
  color: #a94442;
  font-size: 14px;
  padding: 20px 18px;
  line-height: normal;
  text-align: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 64px;
  z-index: 99;

  .v-icon,
  span {
    vertical-align: middle;
    display: inline-block;
  }

  .v-icon {
    margin-right: 5px;
  }
}
</style>
